module.exports = {
          srcSet: __webpack_public_path__ + "8370202e12f7477acd2ae79dcb13326a-167.png"+" 167w",
          images:[ {path: __webpack_public_path__ + "8370202e12f7477acd2ae79dcb13326a-167.png",width: 167,height: 175}],
          src: __webpack_public_path__ + "8370202e12f7477acd2ae79dcb13326a-167.png",
          toString:function(){return __webpack_public_path__ + "8370202e12f7477acd2ae79dcb13326a-167.png"},
          
          width: 167,
          height: 175
        }